/*
 * Редактирование кейсета - https://tanker.yandex-team.ru/project/adv-frontend-filters/keyset/filters%2FfilterWithSuggest%2FcreateFilterSelectWithSuggest.i18n.ts
 * Документация локализации - https://a.yandex-team.ru/arcadia/adv/frontend/docs/monorepo/i18n.md
 */
import { createI18n, createI18nRaw, createKeyset } from '@adv-frontend/l10n/src/i18n';
const keyset = createKeyset({
    'выбрано {count}': {
        ru: {
            one: 'выбрано {count}',
            some: 'выбрано {count}',
            many: 'выбрано {count}',
            none: 'выбрано {count}',
        },
        en: {
            one: '{count} selected',
            some: '{count} selected',
            many: '{count} selected',
            none: '{count} selected',
        },
        'en-IE': {
            one: '{count} selected',
            some: '{count} selected',
            many: '{count} selected',
            none: '{count} selected',
        },
        tr: {
            one: '{count} seçildi',
            some: '{count} seçildi',
            many: '{count} seçildi',
            none: '{count} seçildi',
        },
        'zh-Hans': {
            one: '已选择{count}',
            some: '已选择{count}',
            many: '已选择{count}',
            none: '已选择{count}',
        },
    },
    'Выбрано слишком много значений': {
        ru: 'Выбрано слишком много значений',
        en: 'Too many values selected',
        'en-IE': '',
        tr: 'Çok fazla değer seçildi',
        'zh-Hans': '选择的值过多',
    },
});
export const i18n = createI18n(keyset);
export const i18nRaw = createI18nRaw(keyset);
